import './FeatureHighlight.css';
export var FeatureHighlightCloseButtonCSS = '_1t60p5x2-3-8-0';
export var FeatureHighlightPointerArrowCSS = '_1t60p5x1-3-8-0';
export var FeatureHighlightScrollContainerCSS = '_1t60p5x0-3-8-0';